import { getSolanaConnection } from '../connection';
import { decodeGlobalConfigAccount } from '../decoders/globalConfig';
import { getGlobalConfigPda } from '../pdas/globalConfig';

export async function fetchGlobalConfig() {
  const connection = getSolanaConnection();
  const publicKey = getGlobalConfigPda();
  const accountInfo = await connection.getAccountInfo(publicKey, 'confirmed');

  if (!accountInfo) {
    throw new Error('global_config account was not found.');
  }

  return {
    publicKey: publicKey.toBase58(),
    data: decodeGlobalConfigAccount(accountInfo.data),
  };
}
